import { useWatch } from "react-hook-form";

import { DateInput } from "@/components/admin/date-input";
import { DateTimeInput } from "@/components/admin/date-time-input";

import { useAjustes } from "../datos/useAjustes";
import type { Etapa } from "../dominio/tipos";

/** Fecha de consultoría, presentación o vuelta según la etapa elegida en el formulario. */
export const CamposPorEtapa = ({
  readOnly = false,
}: { readOnly?: boolean } = {}) => {
  const etapa = useWatch({ name: "etapa" }) as Etapa | undefined;
  const { ajustes } = useAjustes();
  if (etapa === "consultoria_agendada") {
    // 41: con el calendario propio la hora se cambia con «Cambiar la hora» (comprueba quién está libre).
    return (
      <DateTimeInput
        source="fecha_reunion"
        helperText={false}
        readOnly={readOnly || ajustes.agenda.propia}
      />
    );
  }
  if (etapa === "presentacion_agendada") {
    return (
      <DateTimeInput
        source="fecha_presentacion"
        helperText={false}
        readOnly={readOnly}
      />
    );
  }
  if (etapa === "largo_plazo") {
    return (
      <DateInput source="fecha_vuelta" helperText={false} readOnly={readOnly} />
    );
  }
  return null;
};
